import React, { memo, useEffect, useMemo, useState } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"

import styles from "./styles.module.css"
import { $getNodeByKey } from "lexical"

import { $isMarkNode } from "@lexical/mark"
import { CommentsPanelListComment } from "./CommentPanelListComment"
import { CommentsComposer } from "./CommentComposer"
import { Box } from "@mos-cat/ds"

export const CommentsPanelList = memo(
  ({
    activeID,
    comments,
    mainComment,
    markNodeMap,
    setShowComments,
    clickComment,
    setIsEditComment,
  }) => {
    return (
      <>
        {!!comments?.length && (
          <Box className={styles.CommentPlugin_CommentsPanel_List_Thread_Comments}>
            {comments.map((replyComment) => (
              <CommentsPanelListComment
                key={replyComment.id}
                activeID={activeID}
                markNodeMap={markNodeMap}
                comment={replyComment}
                setShowComments={setShowComments}
                clickComment={clickComment}
                setIsEditComment={setIsEditComment}
              />
            ))}
          </Box>
        )}
        <>
          {!mainComment?.approved && (
            <div className={styles.CommentPlugin_CommentsPanel_List_Thread_Editor}>
              <CommentsComposer thread={mainComment} />
            </div>
          )}
        </>
      </>
    )
  },
)

CommentsPanelList.displayName = "CommentsPanelList"
